import {getTheme, ITheme, Panel, PanelType} from '@fluentui/react';
import React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import SplitPane, {Pane} from 'react-split-pane';
import history from '../../history';
import {messageService} from '../../services/messageService';
import ConfirmationDialog from '../../shared/confirmationDialog/confirmationDialog';
import {getContractingUnit, getProject, getTimeZone} from '../../shared/util';
import {pmolFormData, ProjectMolecule} from '../../types/projectMolecule';
import {BookMarkItem} from '../../types/template';
import '../style/style.css';
import CommandBarLeft from './commandBar/commandBarLeft';
import CommandBarRight from './commandBar/commandBarRight';
import DocumentPane from './documentPane/container';
import DocumentPaneSection from '../../shared/mainUI/documentPaneSection/documentPaneSection';
import withMainUI from '../../shared/mainUI/withMainUI';
import ListPane from './listPane/container';
import ListPaneSection from '../../shared/mainUI/listPaneSection/component';
import ShortCutPane from './../stock/shortCutPane/container';
import {
  clearFormData,
  filterWorkFlowListPaneData,
  readByWorkFlowId,
  readWorkFlowDropDownData,
} from '../../reducers/workFlowReducer';
import {readStockShortCutPaneData} from '../../reducers/stockReducer';
import {WorkFlowListItem, WorkFlowListPaneFilter, WorkFlowShortCutPaneItem} from '../../types/workFlow';
import {Sorter, StockShortCutPaneMain, StockShotcutPaneFilter} from '../../types/stock';
import {readWarehouseTaxonomy, readWarehouseTaxonomyForProject} from '../../reducers/warehouseReducer';
import moment from 'moment';
import {resizerStyle} from '../../shared/customStyle/commonStyles';

export interface State {
  selectedShortCutItem: StockShotcutPaneFilter;
  filterModified: StockShotcutPaneFilter;
  filter: any;
  formData: ProjectMolecule;
  loading: boolean;
  showPanel: boolean;
  width: number;
  activeClass: string;
  bookmarkDivClass: string;
  showDetails: boolean;
  autoSave: boolean;
  isEdit: boolean;
  isDisableNewButton: boolean;
  isDrag: boolean;
  resetLayout: boolean;
  collapseBookmarkPane: boolean;
  reSizer: number;
  projectId: null | string
}

interface Props extends WithTranslation {
  match: any;
  resetFormData: () => void;
  showProgressBar: boolean;
  shortCutPaneFilters: WorkFlowShortCutPaneItem[];
  formData: any;
  setUid: () => void;
  clearUid: () => void;
  resetIsChange: () => void;
  uid: string | null;
  autoSave: boolean;
  isChange: boolean;
  isEdit: boolean;
  isDataLoaded?: boolean;
  loadMsg: string;
  location: any;
  loading: boolean;
  handleShowDocumentPane: (collapseBookmarkPane?: boolean) => void;
  reSizer: number;
  collapseBookmarkPane: boolean;
  showDetails: boolean;
  showPanel: boolean;
  handleScroll: () => void;
  currentActiveSection: string;
  animation: any;
  readStockShortCutPaneData: () => void;
  filterWorkFlowListPaneData: (filter: StockShotcutPaneFilter) => void;
  readWorkFlowDropDownData: () => void;
  readByWorkFlowId: (id: string) => void;
  clearFormData: () => void;
  shortcutPaneData: StockShortCutPaneMain;

  wfList: WorkFlowListItem[];
  isWFListLoaded: boolean;
  wfDropDowns: any;
  reloadListPane: boolean;
  readWarehouseTaxonomyForProject: any
}

class WorkFlowMainLayout extends React.Component<Props, State> {
  _isMounted = false;
  theme: ITheme = getTheme();
  subscription: any;

  bookmarkList: BookMarkItem[] = [
    {
      id: 1,
      link: 'wf-header',
      label: this.props.t('workflowHeader'),
    },
    {
      id: 2,
      link: 'wf-activity',
      label: this.props.t('workflowActivity'),
    },
    { id: 3, link: 'wf-grid', label: this.props.t('workflowTask') },
    { id: 4, link: 'history', label: this.props.t('history') },
  ];

  constructor(props: Props) {
    super(props);
    this.state = {
      filter: new WorkFlowListPaneFilter(),
      filterModified: new StockShotcutPaneFilter(),
      selectedShortCutItem: {
        id: null,
        title: null,
        name: null,
        type: null,
        status: null,
        wharehouseTaxonomy: null,
        wareHouse: null,
        sorter: new Sorter(),
        typeId: null,
        resourceType: null,
      },
      isEdit: false,
      autoSave: false,
      loading: false,
      width: window.innerWidth,
      showPanel: false,
      activeClass: 'grid-righter column-filter-activated',
      bookmarkDivClass: 'bookmark-panel parent',
      showDetails: false,
      formData: pmolFormData,
      isDisableNewButton: false,
      isDrag: false,
      resetLayout: false,
      collapseBookmarkPane: false,
      reSizer: screen.width,
      projectId: null,
    };
  }

  componentDidMount() {
    this.handleUrlChange();
    this.props.readWorkFlowDropDownData();
    this.props.readStockShortCutPaneData();
    // this.props.readWarehouseTaxonomy({wareHouseId:null})
    // this.props.filterWorkFlowListPaneData(new StockShotcutPaneFilter());

    if (
      location.pathname.split('/').pop() === 'new' &&
      this.state.formData &&
      this.state.formData.id === null
    ) {
      this.createNew();
    }
    this.setState(
      {
        formData: this.props.formData,
      },
      this.props.handleShowDocumentPane,
    );
    this.subscription = messageService.getMessage().subscribe((data: any) => {
      if (data) {
        if (data.data.hideDocumentPane) {
          this.hideDocumentPane();
        }

        if (data.data.isNewWF) {
          this.createNew();
        }

      }
    });
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.props.reloadListPane !== prevProps.reloadListPane && this.props.reloadListPane) {
      this.reloadListPaneItem();
    }
    if (this.props.match.url !== prevProps.match.url) {
      this.handleUrlChange(prevState.collapseBookmarkPane);
    }
    if (this.props.formData !== prevProps.formData && this.props.formData?.project) {
      this.props.readWarehouseTaxonomyForProject({ wareHouseId: null }, this.props.formData.project);
      this.setState({
        formData: this.props.formData,
      });
    }
    if (this.props.collapseBookmarkPane !== prevProps.collapseBookmarkPane) {
      this.setState({
        collapseBookmarkPane: this.props.collapseBookmarkPane,
      });
    }
    if (
      this.props.location &&
      this.props.location.state &&
      this.state.filter !== this.props.location.state.stockSCFilter
    ) {
      if (this.props.location.state.stockSCFilter) {
        const filter = this.props.location.state.stockSCFilter;
        let filterModified = this.props.location.state.stockSCFilter;
        // if (filter.id === TYPE_ALL_SC) {
        //   filterModified = {
        //     ...filterModified,
        //     type: null
        //   }
        // }

        // if (filter.id === GOOD_PICKING_SC) {
        //   filterModified = {
        //     ...filterModified,
        //     type: GOOD_PICKING
        //   }
        // }

        // if (filter.id === GOOD_RECEPTION_SC) {
        //   filterModified = {
        //     ...filterModified,
        //     type: GOOD_RECEPTION
        //   }
        // }

        filterModified = {
          ...filterModified,
          title: this.state.filter.title,
          targetDateTime: this.state.filter.targetDateTime,
          executedDateTime: this.state.filter.executedDateTime,
          //type: this.state.filter.type ? this.state.filter.type : filterModified?.type,
          type: this.state.filter.type ? ((this.state.filter.type === 0 || this.state.filter.type === 1) ? null : this.state.filter.type) : filterModified.id,
          localDate: moment().toISOString(),
          offSet: getTimeZone(),
          status: this.state.filter.status !== '0' ? this.state.filter.status : null,
          requester: this.state.filter.requester,
          executer: this.state.filter.executer,
        };


        // filterModified = {
        //   ...filterModified,
        //   type: filterModified?.id
        // }
        messageService.sendMessage({ selectedShortCutPaneItem: this.props.location.state?.stockSCFilter.id });
        this.setState(
          {
            filter: filter,
            filterModified: filterModified,
          },
          this.reloadListPaneItem,
        );
      }
    }
  }

  handleUrlChange(collapseBookmarkPane?: boolean) {
    let id = this.props.match.params.featureId ? this.props.match.params.featureId : null;
    let isNew = location.pathname.split('/').pop() === 'new';

    if (id && id != 'new') {
      this.setState(
        {
          isEdit: !!this.props.match.params.featureId,
          isDisableNewButton: id ? true : false,
        }, () => {
          this.props.handleShowDocumentPane(collapseBookmarkPane);
        });
      this.props.readByWorkFlowId(id);
    } else {
      this.setState(
        {
          isEdit: false,
          isDisableNewButton: false,
        }, () => {
          this.props.handleShowDocumentPane();
        });
    }
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  // 2. clear states in this method and save to state
  // 3. update redirect url
  createNew = (): void => {
    this.props.clearFormData();
    //this.props.setUid();
    let formData: any = {
      title: null,
      // ....
    };
    this.setState({
      formData: formData,
    });
    if (getContractingUnit() && !getProject()) {
      history.push(`/CU/${getContractingUnit()}/stock-workflow/new`);
    } else {
      history.push(`/CU/${getContractingUnit()}/project/${getProject()}/stock-workflow/new`);
    }
  };

  reloadListPaneItem = () => {
    //
    //this.props.resetIsChange();
    setTimeout(() => {
      const { name, ...result } = this.state.filterModified;
      if (result.type === 1) {
        result.type = null;
      }
      this.props.filterWorkFlowListPaneData({ ...result, name: null });
    }, 100);
  };

  renderShortCutPane = () => {
    return (
      <ShortCutPane
        projectId={this.state.projectId}
        shortCutPaneFilters={this.props.shortcutPaneData}
        filter={this.state.filter}
        handelShortCutPaneFilter={(selectedItem: StockShotcutPaneFilter) =>
          this.handelShortCutPaneFilter(selectedItem)
        }
        toggleOverlay={this.state.collapseBookmarkPane}
        resetLayout={this.state.resetLayout}
        isExpand={this.state.collapseBookmarkPane}
      />
    );
  };

  getDocumentPaneView = () => {
    return (
      <DocumentPaneSection
        collapseBookmarkPane={this.props.collapseBookmarkPane}
        showProgress={this.props.showProgressBar}
        handleScroll={this.props.handleScroll}
        isEdit={this.state.isEdit}
        formData={this.state.formData}
        bookmarkList={this.bookmarkList}
        currentActiveSection={this.props.currentActiveSection}
        renderCommandBar={() => <CommandBarRight isLoading={this.props.showProgressBar}
                                                 formData={this.props.formData}/>}
      >
        <DocumentPane
          formData={this.props.formData}
          wfDropDowns={[]}
          isExpand={false}
          isNewWf={false}
          psDropDowns={[]}/>
      </DocumentPaneSection>
    );
  };

  private getListPaneView = () => {
    return (
      <ListPaneSection
        activeClass={this.state.activeClass}
        titlePaneHeader={
          (this.state.selectedShortCutItem && this.state.selectedShortCutItem.name)
            ? this.state.selectedShortCutItem.name!!
            : this.props.t('workFlow')
        }
        showProgress={this.props.showProgressBar}
        renderCommandBar={() => <CommandBarLeft disable={false}/>}
        renderShotcutPane={() => this.renderShortCutPane()}
      >
        <ListPane
          projectId={this.state.projectId}
          loadMsg={this.props.loadMsg}
          reloadListPaneItem={() => this.reloadListPaneItem()}
          filter={this.state.filterModified}
          listPaneItems={this.props.wfList}
          isDataLoaded={this.props.isWFListLoaded}
          isChange={this.props.isChange}
          formData={this.state.formData}
          handelFilter={(filter: StockShotcutPaneFilter) =>
            this.handleFilter(filter)
          }
          handleSelectedListPaneItem={(
            selectedListItemIds: [] | string[],
          ) => {
            //this.handleSelectedListPaneItem(selectedListItemIds);
          }}
          reSizer={this.props.reSizer}
        />
      </ListPaneSection>
    );
  };

  handleFilter = (filter: StockShotcutPaneFilter) => {
    if ((filter.title && filter.title.length >= 3) || filter.title === null) {
      let filterModified = filter;
      this.setState({
        filter: filter,
        filterModified: filterModified,
      });
      let { name, ...result } = filterModified;
      if (result.status === '0') {
        result = { ...result, status: null };
      }
      if (result.type === '0' || result.type === 1) {
        result = { ...result, type: null };
      }
      if (!this.props.location.state) {
        this.props.filterWorkFlowListPaneData({ ...result, name: null });
      }
    } else {
      this.setState({
        filter: filter,
      });
    }
  };

  handelShortCutPaneFilter = (selectedItem: StockShotcutPaneFilter) => {
    this.setState({
      selectedShortCutItem: selectedItem,
    });
  };

  render() {
    const { t } = this.props;
    return (
      <div>
        <div className={'ms-Grid'}>
          <SplitPane
            className={'SplitPane'}
            split="vertical"
            minSize={300}
            maxSize={screen.width / 2}
            defaultSize={
              this.props.showDetails ? screen.width / 2 : screen.width
            }
            resizerStyle={resizerStyle}
            style={{ height: 'calc(100vh - 129px)' }}
            size={this.props.reSizer}
            onDragStarted={() => {
              this.setState({
                // isDrag:true,
                // collapseBookmarkPane:true,
                // resetLayout:false,
              });
            }}
            onResizerDoubleClick={() => {
              this.setState({
                reSizer: this.props.reSizer === 300 ? screen.width / 2 : 300,
                isDrag: !this.state.isDrag,
                collapseBookmarkPane: !this.state.collapseBookmarkPane,
                resetLayout: !this.state.resetLayout,
              });
            }}
            onDragFinished={(newSize: number) => {
              this.setState({
                // isDrag:false,
                // resetLayout:false,
                reSizer: newSize,
                collapseBookmarkPane: newSize < screen.width / 2,
              });
            }}
            onChange={(newSize: number) => {
              if (newSize === screen.width / 2) {
                this.setState({
                  resetLayout: true,
                  collapseBookmarkPane: false,
                });
              }
            }}
          >
            <Pane className={'SplitPane'}>{this.getListPaneView()}</Pane>
            <Pane className={'SplitPane'}>
              {this.props.showDetails && (
                <div
                  className={`${this.props.animation(this.props.showDetails)}`}
                  style={{
                    display: this.props.showDetails ? 'block' : 'none',
                    transition: 'all 0.9s linear',
                  }}
                >
                  {!this.props.showPanel && (
                    <div>{this.getDocumentPaneView()}</div>
                  )}
                </div>
              )}
            </Pane>
          </SplitPane>
        </div>
        <Panel
          isOpen={this.props.showPanel}
          type={PanelType.smallFixedFar}
          onDismiss={this._hidePanel}
          isLightDismiss={true}
          headerText={t('corporateProductCatalogue')}
          className="custom-detail-panel"
          closeButtonAriaLabel={t('close')}
        >
          {this.getDocumentPaneView()}
        </Panel>

        <ConfirmationDialog
          hidden={true}
          title={t('areyousure')}
          subText={t('youwonTbeabletorevertthis')}
          onClickConfirmDialog={() => {
          }}
          onClickCancelDialog={() => {
          }}
          cancelButtonText={t('noIwonT')}
          confirmButtonText={t('yesDeleteit')}
        />
      </div>
    );
  }

  private _hidePanel = () => {
    this.setState({ showPanel: false, showDetails: false });
    history.push(`/projects/project/${this.state.projectId}/product/pbs`);
  };

  private hideDocumentPane = () => {
    if (getContractingUnit() && getProject()) {
      history.push(`/CU/${getContractingUnit()}/project/${getProject()}/stock-workflow`);
    } else if (getContractingUnit()) {
      //history.push(`/template`);
      history.push(`/CU/${getContractingUnit()}/stock-workflow`);
    }
  };
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    shortcutPaneData: state.stock?.stockShortCutPaneData,
    isWFListLoaded: state.wf.isWFListLoaded,
    wfList: state.wf.wfList,
    wfDropDowns: state.wf.wfDropDowns,
    reloadListPane: state.wf.reloadListPane,
    formData: state.wf.formData,
    showProgressBar: state.wf.showProgressBar,

  };
};

const mapDispatchToProps = {
  readStockShortCutPaneData,
  filterWorkFlowListPaneData,
  readWorkFlowDropDownData,
  readByWorkFlowId,
  clearFormData,
  readWarehouseTaxonomy,
  readWarehouseTaxonomyForProject,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(withMainUI((WorkFlowMainLayout))),
  ));
